module.exports = __webpack_public_path__ + "static/img/1.34670ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/1.png
// module id = PH1z
// module chunks = 0